module.exports = __webpack_public_path__ + "img/menu-up.1414c892.svg";